<div class="flex flex-col">
    @if(integration.connected){
    <div class="flex flex-col items-center gap-2">
        <div class="px-2 py-1 bg-green-100 rounded-lg">
            <span class="text-success font-medium">Connected</span>
        </div>

    </div>
    }@else{
    <div class="flex flex-col items-center gap-2">
        <div class="px-2 py-1 bg-red-100 rounded-lg">
            <span class="text-danger font-medium">Disconnected</span>
        </div>
    </div>
    }
    <div class="flex">
        <form [formGroup]="databaseForm">
            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <label for="connectionString">Connection Url</label>
                    <div class="flex items-center gap-2">
                        <span class="text-sm text-gray-600">Edit Connection Url</span>
                        <app-toggle [(ngModel)]="isConnectionUrlEditable"
                            [ngModelOptions]="{standalone: true}"></app-toggle>
                    </div>
                </div>
                <div>
                    <input type="text" id="connectionString" [(ngModel)]="connectionUrl"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="onConnectionUrlChange($any($event.target).value)"
                        class="p-2 w-full border bg-gray-50 text-gray-600" pInputText
                        [placeholder]="getDefaultPlaceholder()" [disabled]="!isConnectionUrlEditable"
                        [class.opacity-50]="!isConnectionUrlEditable"
                        [class.cursor-not-allowed]="!isConnectionUrlEditable">
                </div>
                <!-- <div class="flex gap-2 text-sm text-gray-600 text-center items-center justify-center">
                        <hr class="w-full">
                    </div> -->

                <!-- <div class="flex gap-2 text-sm text-gray-600 text-center items-center justify-center">
                        <i class="pi pi-info-circle"></i>
                        <span>Recommended: use read-only user for data security</span>
                    </div> -->
            </div>
            <div class="mt-2 flex gap-2">
                <div class="flex-1">
                    <div><label for="host">Host <span class="text-red-500">*</span></label></div>
                    <div>
                        <input type="text" id="host" placeholder="Host Name" class="p-2 w-full border bg-transparent"
                            pInputText formControlName="host">
                    </div>
                </div>
                <div class="flex-1">
                    <div><label for="port">Port</label></div>
                    <div>
                        <input type="text" id="port" class="text-sm placeholder:text-xs"
                            [placeholder]="getDefaultPorts()[databaseType] ?  getDefaultPorts()[databaseType] : 'Port Number'"
                            class="p-2 w-full border bg-transparent" pInputText formControlName="port">
                    </div>
                </div>
                <div class="flex-1">
                    <div><label for="database">Database <span class="text-red-500">*</span></label></div>
                    <div>
                        <input type="text" id="database"
                            [placeholder]="databaseType === 'sqlite' ? 'Enter database file path' : 'Database Name'"
                            class="p-2 w-full border bg-transparent" pInputText formControlName="database">
                    </div>
                </div>
            </div>
            <div class="mt-2 flex gap-2">
                <div class="flex-1">
                    <div><label for="user">User <span class="text-red-500">*</span></label></div>
                    <div>
                        <input type="text" id="user" placeholder="Enter user" class="p-2 w-full border bg-transparent"
                            pInputText formControlName="user">
                    </div>
                </div>

                <div class="flex-1">
                    <div><label for="password">Password <span class="text-red-500">*</span></label></div>
                    <div class="">
                        <p-password id="password" type="password" formControlName="password" class="w-full"
                            [feedback]="false" placeholder="Enter password"
                            class="p-password p-component p-inputwrapper p-input-icon-right rounded bg-transparent"
                            [style]="{'width':'100%'}" [inputStyle]="{'width':'100%','padding' : '8px'}"
                            [toggleMask]="true"></p-password>
                    </div>
                </div>

            </div>


        </form>
    </div>
    <div class="flex mt-6 gap-4 justify-between">
        <div class="flex-1">
            <app-button variant="outlined" severity="contrast" label="Save" (clicked)="saveDatabaseSettings()" />
        </div>
        <div class="flex gap-2 items-center">
            @if(integration.connected){
            <app-button variant="outlined" severity="contrast" label="Disconnect" [loading]="isDisconnecting"
                (clicked)="onDisconnect()" />
            }
            @else {
            <app-button variant="filled" severity="primary" [loading]="isConnecting"
                label="{{integration.connected ? 'Connected' : 'Connect'}}"
                [disabled]="integration.connected ? true : false" (clicked)="onConnect()" />
            }
        </div>

    </div>
</div>